














































































































































import Vue from 'vue';
import Topic from '../../../settings/models/Topic';
import { PropType } from '../../../customer/models/CustomerProp';
import commonVuex from '../../../common/vuex/common';
import customerVuex from '../../../customer/vuex/common';
import {
  CustomFilter,
  CustomerFilter,
  FilterCompare,
  sceneItems,
  SceneItem,
} from '../../../customer/models/CustomerFilter';
import { BROADCAST } from '../../../mass/models/Broadcast';
import Filters from '../../../customer/vuex/filters';

export default Vue.extend({
  mixins: [commonVuex],
  props: {
    customerFilter: {
      type: Object,
      default: null,
    },
    customerGroups: {
      type: Array,
      default: (): any => [],
    },
    memberCards: {
      type: Array,
      default: (): any => [],
    },
    showInteractType: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      PropType,
      FilterCompare,
      BROADCAST,
    };
  },
  computed: {
    remarkNames(): string {
      const rs = this.customerFilter.remark.remarks || [];
      const gs = this.customerFilter.remark.remarkGroups || [];
      const remarkNames = rs.map((r: any) => r ? r.remarkName : '');
      const groupNames = gs.map((g: any) => (g && g.name) || '');
      return groupNames.concat(remarkNames).join('、');
    },
    interactTypeDisplay(): string {
      if (!this.customerFilter.interact.interactiveType) {
        return '所有';
      } else {
        if (this.customerFilter.interact.interactiveType.length > 1) {
          return '发送消息';
        } else if (this.customerFilter.interact.interactiveType.length === 1) {
          switch (this.customerFilter.interact.interactiveType[0]) {
            case BROADCAST.INTERACT_TYPE.ALL:
              return '所有';
            case BROADCAST.INTERACT_TYPE.TEXT:
              return '发送文字';
            case BROADCAST.INTERACT_TYPE.IMAGE:
              return '发送图片';
            case BROADCAST.INTERACT_TYPE.VOICE:
              return '发送语音';
            case BROADCAST.INTERACT_TYPE.MENU:
              return '点击自定义菜单';
            case BROADCAST.INTERACT_TYPE.SUBSCRIBE:
              return '关注';
            case BROADCAST.INTERACT_TYPE.SCAN:
              return '扫描参数二维码';
            case BROADCAST.INTERACT_TYPE.CHECK:
              return '签到';
            default:
              return '所有';
          }
        }
      }
    },
    interactDisplay(): string {
      const period = this.customerFilter.interact.period;
      if (period === 0) {
        return '今天';
      } else if (period === 2) {
        return '48小时内';
      } else if (period === 180) {
        return '最近半年';
      } else if (period === 365) {
        return '最近1年';
      } else {
        return `最近${period}天`;
      }
    },
    traceDisplay() {
      const trace = this.customerFilter.trace;
      let prefix = '';
      if (trace.compare > 0) {
        prefix += `互动大于等于${trace.count}次`;
      } else {
        prefix += `互动小于${trace.count}次`;
      }
      return prefix;
    },
    filterNothing(): boolean {
      const filter = this.customerFilter;
      return !Filters.isFilterSex(filter) &&
             !Filters.isFilterSubscribe(filter) &&
             !Filters.isFilterArea(filter) &&
             !Filters.isFilterSubscribeScene(filter) &&
             !Filters.isFilterInteract(filter) &&
             !Filters.isFilterTrace(filter) &&
             !Filters.isFilterScore(filter) &&
             !Filters.isFilterScoreSum(filter) &&
             !Filters.isFilterMember(filter) &&
             !Filters.isFilterGroup(filter) &&
             !Filters.isFilterTopics(filter) &&
             !Filters.isFilterRemark(filter) &&
             !Filters.isFilterCustom(filter) &&
             !Filters.isFilterTopic(filter);
    },
    isFilterSex(): boolean {
      return this.customerFilter && this.customerFilter.sex !== -1;
    },
    isFilterSubscribe(): boolean {
      const filter = this.customerFilter;
      return Filters.isFilterSubscribe(filter);
    },
    isFilterArea(): boolean {
      const filter = this.customerFilter;
      return Filters.isFilterArea(filter);
    },
    isFilterSubscribeScene(): boolean {
      const filter = this.customerFilter;
      return Filters.isFilterSubscribeScene(filter);
    },
    isFilterInteract(): boolean {
      const filter = this.customerFilter;
      return Filters.isFilterInteract(filter);
    },
    isFilterTrace(): boolean {
      const filter = this.customerFilter;
      return Filters.isFilterTrace(filter);
    },
    isFilterScore(): boolean {
      const filter = this.customerFilter;
      return Filters.isFilterScore(filter);
    },
    isFilterScoreSum(): boolean {
      const filter = this.customerFilter;
      return Filters.isFilterScoreSum(filter);
    },
    isFilterMember(): boolean {
      const filter = this.customerFilter;
      return Filters.isFilterMember(filter);
    },
    isFilterGroup(): boolean {
      const filter = this.customerFilter;
      return Filters.isFilterGroup(filter);
    },
    isFilterRemark(): boolean {
      const filter = this.customerFilter;
      return Filters.isFilterRemark(filter);
    },
    isFilterCustom(): boolean {
      const filter = this.customerFilter;
      return Filters.isFilterCustom(filter);
    },
    validCustoms(): CustomFilter[] {
      return this.customerFilter.custom.filter((custom: CustomFilter) => {
        if (custom.prop === undefined) {
          return false;
        } else {
          if ([PropType.LocalDate, PropType.DateTime].includes(custom.prop.propType)) {
            return custom.date;
          } else if (PropType.Numeric === custom.prop.propType) {
            return custom.num !== undefined;
          } else {
            return custom.keywords && custom.keywords.length;
          }
        }
      });
    },
  },
  methods: {
    multiContainDisplay(notIn: boolean, or: boolean): string {
      if (notIn) {
        return or ? '排除包含任一' : '排除同时包含';
      } else {
        return or ? '包含任一' : '同时包含';
      }
    },
    groupsDisplay(ids: number[]): string {
      return ids.map(r => {
        return this.$props.customerGroups.find((g: any) => g.id === r) ? this.$props.customerGroups.find((g: any) => g.id === r).name : '未知';
      }).join('、');
    },
    membersDisplay(cardIds: number[]): string {
      return cardIds.map(r => {
        return this.$props.memberCards.find((m: any) => m.id === r) ? this.$props.memberCards.find((m: any) => m.id === r).title : '未知';
      }).join('、');
    },
    topicsDisplay(ids: number[]): string {
      return ids.map(r => {
        const tp = this.topics.find((g: any) => g.id === r);
        return  tp ? tp.name : '未知';
      }).join('、');
    },
    getTopic(): Topic {
      const topicId = this.customerFilter.topics[0]; 
      return this.topics.find((r: Topic) => r.id === topicId)!;
    },
    subscribeSceneDisplay(scenes: string[]): string {
      return scenes.map((s: string) => {
        let scene = '';
        Object.keys(sceneItems).forEach((k: string) => {
          const item = sceneItems[k];
          if (item.value === s) {
            scene = item.label;
          }
        });
        return scene;
      }).join('、');
    },
  },
});
